import React from "react";
import { createRoot } from "react-dom/client";
import { LanguageDropdown } from "./language/LanguageDropdown";

// We only mount a small React widget (language dropdown with flags) into the landing page.
// The landing page content itself remains static HTML in `public/index.html`.

const mount = document.getElementById("lang-react");
if (mount) {
  createRoot(mount).render(<LanguageDropdown />);
}


